import { TError, TState } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../members/axios';

type TParams = {
  countryId?: number | null;
};

export const getStatesQueryKey = (countryId: number | null | undefined) => ['geography', 'states', countryId] as const;

export const useGetStatesQuery = ({ countryId }: TParams = {}) =>
  useQuery<TState[], TError>({
    queryKey: getStatesQueryKey(countryId),
    queryFn: async () => {
      const { data } = await axios.get<TState[]>('geography/states', {
        params: { countryId },
      });
      return data;
    },
    enabled: !!countryId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
